import { makeAutoObservable, runInAction } from "mobx";
import apiAgent from "../api/apiAgent"; // Adjust the path to your apiAgent

export default class DealStore {
  deals: any[] = [];
  isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  fetchDeals = async () => {
    this.isLoading = true;
    try {
      const response = await apiAgent.HistoricDeals.getHistoricDeals();
      runInAction(() => {
        this.deals = response;
        this.isLoading = false;
      });
    } catch (error) {
      console.error("Error fetching historic deals:", error);
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  get hasDeals() {
    return this.deals.length > 0;
  }
}

// const dealStore = new DealStore();
// export default dealStore;
